var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIconRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2749_3550)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.8069,
    cy: 26.1475,
    rx: 17.8069,
    ry: 18.1475,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2514 26.1475C46.2514 35.9764 38.4348 43.9325 28.8069 43.9325C19.1791 43.9325 11.3624 35.9764 11.3624 26.1475C11.3624 16.3186 19.1791 8.36245 28.8069 8.36245C38.4348 8.36245 46.2514 16.3186 46.2514 26.1475Z",
    stroke: "white",
    strokeWidth: 0.724899
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2749_3550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8125 20.8477V31.4337",
    stroke: "#11131F",
    strokeWidth: 1.4498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6172 26.1367H34.0046",
    stroke: "#11131F",
    strokeWidth: 1.4498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2749_3550",
    x: 0.126521,
    y: 0.0261157,
    width: 57.3641,
    height: 58.0419,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.89959
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.43674
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0705882 0 0 0 0 0.117647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2749_3550"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2749_3550",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2749_3550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8069,
    height: 18.1475,
    fill: "white",
    transform: "translate(19.9062 17.0703)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconRound);
export default __webpack_public_path__ + "static/media/plusIconRound.4c4b682658e950ccbf1a6f73ba77da1b.svg";
export { ForwardRef as ReactComponent };